/**
 * Klaviyo Back-in-Stock Form Handler
 * Uses event delegation so it works with dynamically-inserted forms
 * (e.g. when variant changes trigger innerHTML replacement via updateSourceFromDestination)
 */
(function() {
  'use strict';

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.hasAttribute('data-klaviyo-bis-form')) return;

    e.preventDefault();

    var emailInput = form.querySelector('input[name="email"]');
    var email = emailInput ? emailInput.value.trim() : '';
    var alertBox = form.querySelector('.klaviyo-bis-alert');
    var submitBtn = form.querySelector('button[type="submit"]');

    if (!email) {
      showAlert(alertBox, 'error', 'Please enter a valid email address.');
      return;
    }

    var variantId = form.getAttribute('data-variant-id');

    var productContainer = form.closest('[class*="product"]');
    if (productContainer) {
      var variantInput = productContainer.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        variantId = variantInput.value;
      }
    }

    if (!variantId) {
      var urlParams = new URLSearchParams(window.location.search);
      variantId = urlParams.get('variant');
    }

    if (!variantId) {
      showAlert(alertBox, 'error', 'Unable to determine product variant. Please refresh and try again.');
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.style.opacity = '0.6';
    }

    var payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email: email }
            }
          },
          channels: ["EMAIL"]
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: "$shopify:::$default:::" + variantId
            }
          }
        }
      }
    };

    var successMsg = form.getAttribute('data-success-msg') || 'You have been registered for notifications.';

    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RVmybc", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(payload)
    })
    .then(function(response) {
      if (response.status === 202) {
        showAlert(alertBox, 'success', successMsg);
        emailInput.value = '';
        var fields = form.querySelectorAll('.field:not(.klaviyo-bis-alert):not(.heading)');
        fields.forEach(function(field) { field.style.display = 'none'; });
      } else {
        return response.json().then(function(data) {
          var msg = 'Something went wrong. Please try again.';
          if (data && data.errors && data.errors.length > 0) {
            msg = data.errors[0].detail || msg;
          }
          showAlert(alertBox, 'error', msg);
        }).catch(function() {
          showAlert(alertBox, 'error', 'Something went wrong. Please try again.');
        });
      }
    })
    .catch(function() {
      showAlert(alertBox, 'error', 'Network error. Please check your connection and try again.');
    })
    .finally(function() {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.style.opacity = '';
      }
    });
  });

  function showAlert(container, status, message) {
    var iconSvg = '';
    if (status === 'success') {
      iconSvg = '<svg class="icon icon-sm shrink-0" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12L11 14L16 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"></path></svg>';
    } else if (status === 'error') {
      iconSvg = '<svg class="icon icon-sm shrink-0" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9V12M12 15H12.01M10.29 3.86L1.82 18C1.64 18.3024 1.54 18.6453 1.53 18.9974C1.52 19.3494 1.60 19.6981 1.76 20.0113C1.93 20.3246 2.17 20.5918 2.47 20.7889C2.76 20.986 3.10 21.1063 3.45 21.1379L3.54 21.14H20.46C20.81 21.1379 21.15 21.0175 21.44 20.8204C21.74 20.6234 21.98 20.3562 22.14 20.043C22.30 19.7298 22.38 19.3811 22.37 19.0291C22.36 18.677 22.26 18.3341 22.08 18.0317L22.02 17.93L13.62 3.86C13.45 3.57 13.21 3.33 12.92 3.15C12.63 2.98 12.30 2.88 11.96 2.87C11.62 2.86 11.28 2.94 10.98 3.10C10.68 3.27 10.42 3.50 10.23 3.78L10.16 3.86H10.29Z"></path></svg>';
    }
    container.innerHTML = '<div class="alert alert--' + status + ' flex items-start gap-3 text-sm md:text-base leading-tight">' + iconSvg + message + '</div>';
    container.style.display = '';
  }
})();
